import CreateValueModule from "@/redux/create-value-module";

import {
    $HasAccountModalUserDataModuleName,
    THasAccountModalUserDataState
} from "./hasAccountModalUserData.types";

const { constants: _constants, actions } =
    CreateValueModule<THasAccountModalUserDataState>(
        $HasAccountModalUserDataModuleName,
        {
            email: ""
        }
    );

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
